import { createContext } from 'react';
import type { PortalSessionGetResponse, VerifiedPerson } from '../hooks/useSessionPolling';

export interface UserContextValue {
  userId: string | null;
  sessionData: VerifiedPerson | null;
  setSessionData: (data: VerifiedPerson | null) => void;
  /** Mirrors server session (student ID offer crs id); cleared when session ends or revoke succeeds. */
  credentialId: string | null;
  /** Apply GET /api/session payload to React state (no browser persistence). */
  syncFromSessionResponse: (json: PortalSessionGetResponse) => void;
  /** Re-fetch GET /api/session and update state. */
  refreshPortalSession: () => Promise<void>;
}

export const UserContext = createContext<UserContextValue>({
  userId: null,
  sessionData: null,
  setSessionData: () => { },
  credentialId: null,
  syncFromSessionResponse: () => { },
  refreshPortalSession: async () => { },
});
